/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useCreateCollectionOrder = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`collections/services/create`, {
        data,
        successMessage: "Request submitted successfully!",
      }),
  });

export const useGetCollectionVaultRequests = () =>
  useMutation({
    mutationKey: ["GetCollectionVaultRequests"],
    mutationFn: (data: any) =>
      client(`collections/services/vault/handover/requests`, { data }),
  });

export const useCollectionAddCashToVault = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`collections/services/add/cash/vault`, {
        data,
        successMessage: "Cash handover to vault successfully!",
      }),
  });
};

export const useGetCollectionsOrders = (data: any) =>
  useQuery({
    queryKey: [
      "GetCollectionsOrders",
      data?.pageNumber,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
      data?.customerId,
      data?.sourceSPId,
    ],
    queryFn: ({ signal }) =>
      client(`collections/services/open/requests`, { data, signal }),
  });

export const useCreateBulkCollectionOrders = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`collections/services/create/bulk/requests`, {
        data,
        successMessage: "Collection requests created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetCollectionsOrders"] });
    },
  });
};

export const useCancelCollectionOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`collections/services/cancel/services`, {
        data,
        successMessage: "Selected job(s) cancelled successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetCollectionsOrders"] });
    },
  });
};

export const useAssignCollectionRoute = () => {
  const queryClient = useQueryClient();
  return useMutation<any>({
    mutationFn: (data: any) =>
      client(`collections/services/assign/route`, {
        data,
        successMessage: "Route assigned successfully for selected jobs!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: ["GetCollectionsOrders"],
      });
    },
  });
};

export const useGetCollectionDetails = (data: any) =>
  useQuery<any>({
    queryKey: ["GetCollectionDetails", data?.requestId],
    queryFn: () =>
      client(`collections/services/request/details/${data?.requestId}`),
    enabled: Boolean(data?.requestId),
  });

export const useEditCollectionJob = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`collections/services/edit/request`, {
        data,
        successMessage: "Request edited successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["GetCollectionDetails"],
      });
    },
  });
};

export const useUpdateCollectionStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`collections/services/update/request/status`, {
        data,
        successMessage: "Request status updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetCollectionDetails"] });
    },
  });
};

export const useGetCollectionNewRequests = (data: any) =>
  useQuery<any>({
    queryKey: [
      "GetCollectionNewRequests",
      data?.operationDate,
      data?.cashCenterId,
    ],
    queryFn: () => client(`collections/services/new/requests`, { data }),
  });

export const useAcceptNewCollectionRequests = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`collections/services/approve`, {
        data,
        successMessage: "Selected requests are accepted successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetCollectionNewRequests"] });
    },
  });
};

export const useGetCollectionCashierRequests = (data: any) =>
  useQuery<any>({
    queryKey: [
      "GetCollectionCashierRequests",
      data?.operationDate,
      data?.cashCenterId,
      data?.assigneeId,
    ],
    queryFn: () =>
      client(`collections/services/processing/area/requests`, { data }),
  });

export const useAssignCashierRequests = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`collections/services/assign/cashier`, {
        data,
        successMessage: "Cashier assigned successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetCollectionCashierRequests"] });
      queryClient.invalidateQueries({ queryKey: ["GetCashierLoads"] });
    },
  });
};

export const useUpdateCollectionAfterCompletion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`collections/services/update/evhr/request`, {
        data,
        successMessage: "Request updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetCollectionDetails"] });
    },
  });
};
